import _ from 'lodash';

function AccountsJoinCtrl($scope, $state, $timeout, $window, $sce, toastr, AppSettings, UserService, PlayerService, CommonService) {
  'ngInject';


  //   service.getInfo = function () {
  //   return JSON.parse($window.sessionStorage.getItem('info'))
  // };

  // service.setInfo = function (u) {
  //   $window.sessionStorage.setItem('info', JSON.stringify(u));
  // };

  function guid() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
      s4() + '-' + s4() + s4() + s4();
  }


  var randomString = Math.floor(Math.random() * 100) + 2 + "" + new Date().getTime() + Math.floor(Math.random() * 100) + 2 + (Math.random().toString(36).replace(/[^a-zA-Z]+/g, '').substr(0, 5));

  const vm = this;
  if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    vm.isDebugger = true;
  }

  vm.isMobile = window.mobilecheck();
  if (location.protocol === 'file:') {
    vm.isMobileApp = true;
    vm.isMobile = true;
  }
  vm.isIpad = !!navigator.userAgent.match(/ipad/gi);
  if (vm.isIpad) {  // 아이패드인 경우 모바일로 처리
    vm.isMobile = true;
  }
  vm.isIOS = !!navigator.userAgent.match(/iphone/gi) || !!navigator.userAgent.match(/ipad/gi);

  const currentYear = (new Date()).getFullYear();

  vm.langs = [{ id: 'ko', name: '한글' }, { id: 'en', name: '영어' }];  // 언어 목록
  vm.selectedLang = vm.langs[0];
  vm.emails = [{ id: 'direct', name: '직접입력', value: '' }, { id: 'naver', name: '네이버', value: 'naver.com' }, { id: 'daum', name: '다음', value: 'daum.net' }, { id: 'hanmail', name: '한메일', value: 'hanmail.net' }, { id: 'gmail', name: '지메일', value: 'gmail.com' }];   // 이메일 제공업체 목록
  vm.selectedEmail = vm.emails[0];
  vm.continents = null; // 대륙 목록
  vm.selectedContinent = null;
  vm.countries = null;  // 국가 목록
  vm.selectedCountry = null;
  vm.sports = null; // 종목 목록
  vm.selectedSport = null;
  vm.userTypes1 = null;  // 신분 1단계 목록
  vm.selectedUserType1 = null;
  vm.userTypes2 = null; // 신분 2단계 목록
  vm.selectedUserType2 = null;
  vm.teams1 = null; // 팀 1단계 목록
  vm.selectedTeam1 = null;
  vm.teams2 = null; // 팀 2단계 목록
  vm.selectedTeam2 = null;
  vm.teams3 = null; // 팀 3단계 목록
  vm.selectedTeam3 = null;
  vm.team4 = null; //팀 4단계 목록
  vm.selectedTeam4 = null;
  vm.positions1 = null; // 포지션 1단계 목록
  vm.selectedPosition1 = null;
  vm.positions2 = null; // 포지션 2단계 목록
  vm.selectedPosition2 = null;
  vm.years = _.range(1940, currentYear);
  vm.months = _.range(1, 13);
  vm.dates = _.range(1, 32);
  vm.back_numbers = _.range(1, 100);
  vm.licenses = null;
  vm.selectedLicense = null;
  vm.movements1 = null; // 동작 1단계 목록
  vm.selectedMovement1 = null;
  vm.movements2 = null; // 동작 2단계 목록
  vm.selectedMovement2 = null;
  vm.movements3 = null; // 동작 3단계 목록
  vm.selectedMovement3 = null;
  vm.apiUrlRestRoot = AppSettings.apiUrl.restRoot;

  // 회원가입 데이터
  vm.joinData = {
    //appr_id: 'ceo@sa21c.com',   // 회원가입시 자동승인되도록 처리, 추후 수정해야 함 => 선수는 자동승인 안되게 막음
    lang_id: null,
    email: {
      first: null,
      second: null
    },
    login_id: null,
    isDuplicate: null,
    passwd: null,
    name: null,
    gender: 'M',
    birthdate: {
      year: '' + (currentYear - 13),
      month: '1',
      date: '1'
    },
    birth_date: null,
    image_url: null,
    min1: '010',
    min2: null,
    min3: null,
    code: null,
    verify_code: null,
    phone1: '02',
    phone2: null,
    phone3: null,
    addr: {
      zip: null,
      detail: null
    },
    address: null,
    country_id: null,
    height: null,
    weight: null,
    blood_type: 'A',
    sport_id: null,
    user_type_id: null,
    team_id: 0,
    position_id: null,
    back_number: '1',
    license_id: null,
    license_no: null,
    agent_id: null,
    users_ids: null,
    teams_ids: null,
    coaches_ids: null,
    staffs_ids: null,
    files: null,
    info_agree_flag: 'N'
  };

  vm.joinData.image_url = './images/user_default.png';

  // 초기 대륙 목록 불러오기
  UserService.getCountries().then(function (res) {
    var data = res.data;
    vm.continents = data.list;
    vm.modalContinents = data.list;
    vm.userContinents = data.list;

    vm.selectedUserContinent = vm.userContinents[0];

    // vm.selectedContinent = vm.continents[0];
    vm.selectedTeamContinent = vm.continents[0];
  });

  // 종목 목록 불러오기
  UserService.getSports().then(function (res) {
    var data = res.data;
    vm.sports = data.list;
    vm.selectedSport = vm.sports[0];
  });

  // 초기 사용자 구분 목록 불러오기
  UserService.getUserTypes().then(function (res) {
    var data = res.data;

    // SA21C 삭제
    // _.remove(data.list, function (n) {
    //   return n.name == 'SA21C';
    // });

    vm.userTypes1 = data.list;
    vm.selectedUserType1 = vm.userTypes1[0];
  });

  // 초기 포지션 목록 불러오기
  UserService.getPositions().then(function (res) {
    var data = res.data;
    vm.positions1 = data.list;
    vm.selectedPosition1 = vm.positions1[0];
  });

  // 자격증 목록 불러오기
  UserService.getLicenses().then(function (res) {
    var data = res.data;
    vm.licenses = data.list;
    vm.selectedLicense = vm.licenses[0];
  });

  // 초기 동작 목록 불러오기
  UserService.getMovements().then(function (res) {
    var data = res.data;
    vm.movements1 = data.list;
    vm.selectedMovement1 = vm.movements1[0];
  });

  // 이메일 제공업체 변경
  $scope.$watch('vm.selectedEmail', function (newVal, oldVal) {
    if (newVal) {
      vm.joinData.email.second = newVal.value;
    }
  });

  // 언어 변경
  $scope.$watch('vm.selectedLang', function (newVal, oldVal) {
    if (newVal) {
      vm.joinData.lang_id = newVal.id;
    }
  });

  // 이메일 변경
  $scope.$watchCollection('vm.joinData.email', function (newVal, oldVal) {
    if (newVal.first && newVal.second) {
      vm.joinData.login_id = newVal.first + '@' + newVal.second;

      UserService.isDuplicate({ login_id: vm.joinData.login_id }).then(function (res) {
        var data = res.data;
        vm.joinData.isDuplicate = data.result;
      });
    }
  });

  vm.over18 = true;
  // 만나이 계산후 18세 이상인지 검사
  function calculateAge(birthDate) {
    var birthday = new Date(birthDate); // birthDate: 2000-09-09
    var today = new Date();
    var years = today.getFullYear() - birthday.getFullYear();
    
    // Reset birthday to the current year.
    birthday.setFullYear(today.getFullYear());
    
    // If the user's birthday has not occurred yet this year, subtract 1.
    if (today < birthday)
    {
        years--;
    }
    
    if (years < 18) {
      vm.over18 = false;
    } else {
      vm.over18 = true;
    }
  }

  // 생년월일 변경
  $scope.$watchCollection('vm.joinData.birthdate', function (newVal, oldVal) {
    if (newVal.year && newVal.month && newVal.date) {
      let month = newVal.month;
      let date = newVal.date;

      if (month < 10) {
        month = '0' + month;
      }
      if (date < 10) {
        date = '0' + date;
      }

      vm.joinData.birth_date = newVal.year + month + date;

      calculateAge(newVal.year + '-' + month + '-' + date);
    }
  });

  // 주소 변경
  $scope.$watchCollection('vm.joinData.addr', function (newVal, oldVal) {
    if (newVal.detail) {
      vm.joinData.address = '(' + (newVal.zip || '') + ') ' + newVal.detail;
    }
  });

  // // 대륙 변경
  // $scope.$watch('vm.selectedContinent', function(newVal, oldVal) {
  //   if (newVal && !newVal.is_last) {
  //     UserService.getCountries({ parent_id: newVal.id }).then(function(res) {
  //       var data = res.data;
  //         vm.countries = data.list;
  //         vm.selectedCountry = vm.countries[0];
  //     });
  //   }
  // });


  // 사용자 대륙 변경
  $scope.$watch('vm.selectedUserContinent', function (newVal, oldVal) {
    if (newVal && !newVal.is_last) {
      UserService.getCountries({ parent_id: newVal.id }).then(function (res) {
        vm.userCountries = res.data.list;

        vm.selectedUserCountry = vm.userCountries[0];
      });
    }
  });



  // 사용자 국가 변경
  $scope.$watch('vm.selectedUserCountry', function (newVal, oldVal) {
    if (newVal) {
      vm.joinData.country_id = newVal.id;
    }
  });

  // 종목 변경
  $scope.$watch('vm.selectedSport', function (newVal, oldVal) {
    if (newVal) {
      vm.joinData.sport_id = newVal.id;
    }
  });

  // 사용자 구분 1단계 변경
  $scope.$watch('vm.selectedUserType1', function (newVal, oldVal) {
    if (newVal && !newVal.is_last) {
      UserService.getUserTypes({ parent_id: newVal.id }).then(function (res) {
        var data = res.data;
        vm.userTypes2 = data.list;
        vm.selectedUserType2 = vm.userTypes2[0];
      });
    } else {
      if (newVal) {
        vm.joinData.user_type_id = newVal.id;
      }

      vm.userTypes2 = null;
    }

    if (newVal && newVal.id == '25' || newVal && newVal.id == '26') {  // 협회, 단체인 경우
      vm.selectedTeam1 = vm.teams1[1];  // 단체
    } else if (newVal && newVal.id == '27') {  // 회사인 경우
      vm.selectedTeam1 = vm.teams1[2];  // 회사
    } else {
      vm.selectedTeam1 = vm.teams1 && vm.teams1[0];
    }
  });

  // 사용자 구분 2단계 변경
  $scope.$watch('vm.selectedUserType2', function (newVal, oldVal) {
    if (newVal) {
      vm.joinData.user_type_id = newVal.id;
    }
  });

  // 대륙 변경
  $scope.$watch('vm.selectedTeamContinent', function (newVal, oldVal) {
    if (newVal) {
      UserService.getCountries({ parent_id: newVal.id }).then(function (res) {
        vm.countries = res.data.list;

        vm.selectedTeamCountry = vm.countries[0];

        vm.teams1 = vm.teams2 = vm.teams3 = vm.teams4 = null;
      });
    }
  });



  var country_id;
  // 국가 변경
  $scope.$watch('vm.selectedTeamCountry', function (newVal, oldVal) {
    if (newVal) {
      country_id = newVal.id
      var data = {
        country_id: country_id
      }
      UserService.getTeams(data)
        .then(function (res) {
          vm.teams1 = res.data.list;

          vm.selectedTeam1 = vm.teams1[0];

          vm.teams2 = vm.teams3 = vm.teams4 = null;

        });
    }
  });

  // 팀 1단계 변경
  $scope.$watch('vm.selectedTeam1', function (newVal, oldVal) {
    if (newVal) {

      var data = {
        country_id: country_id,
        parent_id: newVal.id
      }

      UserService.getTeams(data).then(function (res) {
        vm.teams2 = res.data.list;
        // vm.selectedTeam2 = vm.teams2[0];
        vm.teams3 = vm.teams4 = null;

      });
    }
  });

  // 팀 2단계 변경
  $scope.$watch('vm.selectedTeam2', function (newVal, oldVal) {

    if (newVal) {
      var data = {
        country_id: country_id,
        parent_id: newVal.id
      }

      UserService.getTeams(data).then(function (res) {
        vm.teams3 = res.data.list;
        vm.teams4 = null;
      });
    }
  });

  // 팀 3단계 변경
  $scope.$watch('vm.selectedTeam3', function (newVal, oldVal) {
    if (newVal) {
      var data = {
        country_id: country_id,
        parent_id: newVal.id
      }


      UserService.getTeams(data).then(function (res) {

        vm.teams4 = res.data.list;
        /*
        vm.teams4.unshift({
          id: 'add',
          name: "항목추가 [+]"
        })
        */
      });
    }
  });

  // 팀 4단계 변경
  $scope.$watch('vm.selectedTeam4', function (newVal, oldVal) {
    // if (newVal) {
    //   if (newVal.id != 'add') {
    //     vm.joinData.team_id = newVal.id;
    //   } else {
    //     // alert('1.add team, 2.list refresh')
    //     vm.selectedTeam4 = null;
    //     vm.showItemAdd = true;
    //   }
    // }


    if (newVal) {
      vm.joinData.team_id = newVal.id;
    }

    // if (newVal.id != 'add') {
    //   vm.joinData.team_id = newVal.id;
    // } else {
    //   // alert('1.add team, 2.list refresh')
    //   vm.selectedTeam4 = null;
    //   vm.showItemAdd = true;
    // }


    // 선택한 팀의 선수 목록을 저장해 둠
    // 나중에 선수 가입할 때, 배번 중복검사를 위해
    if (newVal) {
      PlayerService.getPlayers({
        all: 'Y',
        team_id: newVal.id
      })
        .then(function (res) {
          vm.selectedTeamPlayers = res.data.players;
        })
        .catch(function (error) {
          console.log('ERROR ', error)
        });
    }
  });


  // ----------------
  //   modal team select
  // ---------------

  vm.modalTeamContinent = null;
  vm.modalTeamCountry = null;
  vm.modalTeam1 = null;
  vm.modalTeam2 = null;
  vm.modalTeam3 = null;
  vm.modalTeam4 = null;
  vm.modalCoachingSteps = [];   // modal 에서 검색된 지도자 목록
  vm.modalTeamSteps = [];       // modal 에서 검색된 팀 관계자 목록
  vm.modalPlayers = [];
  vm.modalTeams = [];
  vm.modalSelectedCoachingSteps = [];
  vm.modalSelectedTeamSteps = [];
  vm.modalSelectedPlayers = [];
  vm.modalSelectedTeams = [];

  // modal 화면 데이터 초기화
  vm.resetModalTeams = function () {
    vm.modalTeamContinent = null;
    vm.modalTeamCountry = null;
    vm.modalTeam1 = null;
    vm.modalTeam2 = null;
    vm.modalTeam3 = null;
    vm.modalTeam4 = null;

    vm.modalCountries = null;
    vm.modalTeams1 = null;
    vm.modalTeams2 = null;
    vm.modalTeams3 = null;
    vm.modalTeams4 = null;

    vm.modalCoachingSteps = [];
    vm.modalTeamSteps = [];
    vm.modalPlayers = [];
    vm.modalTeams = [];
  };

  // 대륙 변경
  $scope.$watch('vm.modalTeamContinent', function (newVal, oldVal) {
    if (newVal) {
      UserService.getCountries({
        parent_id: newVal.id
      }).then(function (res) {
        vm.modalCountries = res.data.list;
        vm.modalTeams1 = vm.modalTeams2 = vm.modalTeams3 = vm.modalTeams4 = null;
      });
    }
  });

  // var country_id;
  // 국가 변경
  $scope.$watch('vm.modalTeamCountry', function (newVal, oldVal) {
    if (newVal) {
      country_id = newVal.id
      var data = {
        country_id: country_id
      }
      UserService.getTeams(data)
        .then(function (res) {
          vm.modalTeams1 = res.data.list;
          vm.modalTeams2 = vm.modalTeams3 = vm.modalTeams4 = null;
        });
    }
  });

  // 팀 1단계 변경
  $scope.$watch('vm.modalTeam1', function (newVal, oldVal) {
    if (newVal) {

      var data = {
        country_id: country_id,
        parent_id: newVal.id
      }

      UserService.getTeams(data).then(function (res) {
        vm.modalTeams2 = res.data.list;
        // vm.modalTeam2 = vm.modalTeams2[0];
        vm.modalTeams3 = vm.modalTeams4 = null;

      });
    }
  });

  // 팀 2단계 변경
  $scope.$watch('vm.modalTeam2', function (newVal, oldVal) {

    if (newVal) {
      var data = {
        country_id: country_id,
        parent_id: newVal.id
      }

      UserService.getTeams(data).then(function (res) {
        vm.modalTeams3 = res.data.list;
        vm.modalTeams4 = null;
      });
    }
  });

  // 팀 3단계 변경
  $scope.$watch('vm.modalTeam3', function (newVal, oldVal) {
    if (newVal) {
      var data = {
        country_id: country_id,
        parent_id: newVal.id
      }


      UserService.getTeams(data).then(function (res) {
        vm.modalTeams4 = res.data.list;
      });
    }
  });

  var selectedTeam = {};
  // 팀 4단계 변경
  $scope.$watch('vm.modalTeam4', function (newVal, oldVal) {
    if (newVal) {
      // vm.joinData.agency_team_id = newVal.id;
      // vm.joinData.agency_team_name = newVal.name;
      selectedTeam.id = newVal.id;
      selectedTeam.name = newVal.name;

      // 선수, 지도자 소속사 선택
      if (vm.modalMode === 'player_agency') {
        vm.joinData.agent_id = newVal.id;
      }
      // 지도자 검색
      else if (vm.modalMode === 'SearchCoachingStep') {
        var data = {
          all: 'Y',
          team_id: newVal.id
        };

        PlayerService.getPlayers(data)
          .then(function (res) {
            vm.modalCoachingSteps = _.filter(res.data.non_players, {
              'parent_user_type_id': 2
            });
          })
          .catch(function (error) {
            console.log('ERROR ', error)
          });
      }
      // 관계자 검색  
      else if (vm.modalMode === 'SearchTeamStep') {
        var data = {
          all: 'Y',
          team_id: newVal.id
        };

        PlayerService.getPlayers(data)
          .then(function (res) {
            vm.modalTeamSteps = _.filter(res.data.non_players, {
              'parent_user_type_id': 3
            });
          })
          .catch(function (error) {
            console.log('ERROR ', error)
          });
      }
      // 선수 검색
      else if (vm.modalMode === 'FanSearchPlayer') {
        var data = {
          all: 'Y',
          team_id: newVal.id
        };

        PlayerService.getPlayers(data)
          .then(function (res) {
            vm.modalPlayers = res.data.players;
          })
          .catch(function (error) {
            console.log('ERROR ', error)
          });
      }
    }
  });

  // modal 에서 지도자, 관계자 선택
  vm.addRemoveUsers = function (mode, $event, user) {
    // 지도자
    if (mode === 'CoachingStep') {
      if ($event && $event.target.checked) {  // 추가
        vm.modalSelectedCoachingSteps.push(user);
      } else {  // 삭제
        _.remove(vm.modalSelectedCoachingSteps, {
          user_id: user.user_id
        });
      }
    }
    // 관계자
    else if (mode === 'TeamStep') {
      if ($event && $event.target.checked) {  // 추가
        vm.modalSelectedTeamSteps.push(user);
      } else {  // 삭제
        _.remove(vm.modalSelectedTeamSteps, {
          user_id: user.user_id
        });
      }
    }
    // 선수
    else if (mode === 'Player') {
      if ($event && $event.target.checked) {  // 추가
        vm.modalSelectedPlayers.push(user);
      } else {  // 삭제
        _.remove(vm.modalSelectedPlayers, {
          user_id: user.user_id
        });
      }
    }
    // 팀
    else if (mode === 'Team') {
      if ($event) {  // 추가
        vm.modalSelectedTeams.push(user);
      } else {  // 삭제
        _.remove(vm.modalSelectedTeams, {
          id: user.id
        });
      }
    }
  };

  // 팬,일반 선수 선택시 회원가입 데이터에 반영
  $scope.$watchCollection('vm.modalSelectedPlayers', function (newVal, oldVal) {
    if (!newVal || !newVal.length) {
      vm.joinData.users_ids = null;
    } else {
      vm.joinData.users_ids = _.map(newVal, 'user_id');
    }
  });

  // 팬,일반 팀 선택시 회원가입 데이터에 반영
  $scope.$watchCollection('vm.modalSelectedTeams', function (newVal, oldVal) {
    if (!newVal || !newVal.length) {
      vm.joinData.teams_ids = null;
    } else {
      vm.joinData.teams_ids = _.map(newVal, 'id');
    }
  });


  vm.apply = function () {
    vm.joinData.agency_team_id = selectedTeam.id;
    vm.joinData.agency_team_name = selectedTeam.name;

  }

  // ------------------------------------













  // 포지션 1단계 변경
  $scope.$watch('vm.selectedPosition1', function (newVal, oldVal) {
    if (newVal && !newVal.is_last) {
      UserService.getPositions({ parent_id: newVal.id }).then(function (res) {
        var data = res.data;
        vm.positions2 = data.list;
        vm.selectedPosition2 = vm.positions2[0];
      });
    } else {
      if (newVal) {
        vm.joinData.position_id = newVal.id;
      }

      vm.positions2 = null;
    }
  });

  // 포지션 2단계 변경
  $scope.$watch('vm.selectedPosition2', function (newVal, oldVal) {
    if (newVal) {
      vm.joinData.position_id = newVal.id;
    }
  });

  // 자격증 변경
  $scope.$watch('vm.selectedLicense', function (newVal, oldVal) {
    if (newVal) {
      vm.joinData.license_id = newVal.id;
    }
  });

  // 동작 1단계 변경
  $scope.$watch('vm.selectedMovement1', function (newVal, oldVal) {
    if (newVal && !newVal.is_last) {
      UserService.getMovements({ parent_id: newVal.id }).then(function (res) {
        var data = res.data;
        vm.movements2 = data.list;
        vm.selectedMovement2 = vm.movements2[0];
      });
    } else {
      if (newVal) {
        vm.joinData.movement_id = newVal.id;
      }

      vm.movements2 = null;
      vm.movements3 = null;
    }
  });

  // 동작 2단계 변경
  $scope.$watch('vm.selectedMovement2', function (newVal, oldVal) {
    if (newVal && !newVal.is_last) {
      UserService.getMovements({ parent_id: newVal.id }).then(function (res) {
        var data = res.data;
        vm.movements3 = data.list;
        vm.selectedMovement3 = vm.movements3[0];
      });
    } else {
      if (newVal) {
        vm.joinData.movement_id = newVal.id;
      }

      vm.movements3 = null;
    }
  });

  // 동작 3단계 변경
  $scope.$watch('vm.selectedMovement3', function (newVal, oldVal) {
    if (newVal) {
      vm.joinData.movement_id = newVal.id;
    }
  });

  // 사진 이미지 업로드
  var fileUploadOptions = {
    forceIframeTransport: (vm.isMobileApp ? false : true),
    url: AppSettings.apiUrl.restRoot + 'user/upload_image',
    //dataType: 'json',
    fileInput: $('#upload_image'),
    submit: function(e, data) {
      console.log('submit', e, data);
    },
    /*
    add: function(e, data) {
      console.log('add', e, data);
      if (data.autoUpload || (data.autoUpload !== false &&
        $(this).fileupload('option', 'autoUpload'))) {
          data.process().done(function () {
              data.submit();
          });
      }
    },
    send: function(e, data) {
      console.log('send', e, data);
    },
    always: function(e, data) {
      console.log('always', e, data);
    },
    progress: function(e, data) {
      console.log('progress', e, data);
    },
    progressall: function(e, data) {
      console.log('progressall', e, data);
    },
    start: function(e, data) {
      console.log('start', e, data);
    },
    stop: function(e, data) {
      console.log('stop', e, data);
    },
    change: function(e, data) {
      console.log('change', e, data);
    },
    */
    done: function (e, data) {
      var result;
      console.log('data', data);
      // iOS
      if (data.result && typeof data.result === 'string') {
        var obj = JSON.parse(data.result);
        $scope.$apply(function () {
          vm.joinData.image_url = obj.image_url;
        });
      }
      // PC, Android
      else if (data.result && data.result[0].body) {
        result = data.result[0].body.innerHTML;
        if (!isJSON(result)) {   // 구글 번역으로 인해 JSON 이외에 html tag 가 같이 온 경우
          if (result.match('div')) {
            var temp = result.split('{'),
              temp2 = temp[1].split('}');
            result = '{' + temp2[0] + '}';
          }
        }
        $scope.$apply(function () {
          vm.joinData.image_url = (JSON.parse(result)).image_url;
        });
      }

    }
  };
  // Android, iOS
  if (!vm.isMobileApp) {
    fileUploadOptions.redirect = location.origin + '/#!/result';
  }
  // iOS
  if (vm.isIOS) {
    fileUploadOptions.add = function(e, data) {
      console.log('add', e, data);
      if (data.autoUpload || (data.autoUpload !== false &&
        $(this).fileupload('option', 'autoUpload'))) {
          data.process().done(function () {
              data.submit();
          });
      }
    };
  }
  $('#upload_image').fileupload(fileUploadOptions);
  /*
  $('#upload_image')
    .bind('fileuploadadd', function (e, data) {console.log('fileuploadadd');})
    .bind('fileuploadsubmit', function (e, data) {console.log('fileuploadsubmit');})
    .bind('fileuploadsend', function (e, data) {console.log('fileuploadsend');})
    .bind('fileuploaddone', function (e, data) {console.log('fileuploaddone');})
    .bind('fileuploadfail', function (e, data) {console.log('fileuploadfail');})
    .bind('fileuploadalways', function (e, data) {console.log('fileuploadalways');})
    .bind('fileuploadprogress', function (e, data) {console.log('fileuploadprogress');})
    .bind('fileuploadprogressall', function (e, data) {console.log('fileuploadprogressall');})
    .bind('fileuploadstart', function (e) {console.log('fileuploadstart');})
    .bind('fileuploadstop', function (e) {console.log('fileuploadstop');})
    .bind('fileuploadpaste', function (e, data) {console.log('fileuploadpaste');})
    .bind('fileuploaddrop', function (e, data) {console.log('fileuploaddrop');})
    .bind('fileuploaddragover', function (e) {console.log('fileuploaddragover');})
    .bind('fileuploadchunksend', function (e, data) {console.log('fileuploadchunksend');})
    .bind('fileuploadchunkdone', function (e, data) {console.log('fileuploadchunkdone');})
    .bind('fileuploadchunkfail', function (e, data) {console.log('fileuploadchunkfail');})
    .bind('fileuploadchunkalways', function (e, data) {console.log('fileuploadchunkalways');});
  */

  // 인증하기 버튼 클릭
  vm.sendCode = function () {
    UserService.sendCode({ min1: vm.joinData.min1, min2: vm.joinData.min2, min3: vm.joinData.min3 }).then(function (res) {
      var data = res.data;
      if (data.result === 'SUC') {
        vm.joinData.code = data.code;
      }
    });
  };

  // 인증확인 버튼 클릭
  vm.verifyCode = function () {
    UserService.verifyCode({ code: vm.joinData.code, min1: vm.joinData.min1, min2: vm.joinData.min2, min3: vm.joinData.min3 }).then(function (res) {
      var data = res.data;
      if (data.result === 'SUC') {
        vm.joinData.verify_code = true;
      }
    });
  };

  vm.addItem = function (item) {
    if (!item) {
      toastr.error('팀명을 입력하세요.');
      return;
    }
    alert('add item : ' + item + ', refresh data');
    vm.showItemAdd = false;
  }

  // 회원 가입
  vm.submit = function () {

    // 소속팀을 선택하지 않고 team_id 가 0 인 상태로 가입 후 조직관리에서 팀을 선택하거나 생성할 수 있도록 아래는 주석 처리
    // if (!vm.joinData.team_id) {
    //   toastr.error('소속팀을 선택하세요');
    //   return;
    // }

    if (!vm.joinData.country_id) {
      toastr.error('국가를 선택하세요');
      return;
    }

    if (!vm.joinData.email.first || !vm.joinData.email.second) {
      toastr.error('이메일을 입력하세요.');
      return;
    }

    if (vm.joinData.isDuplicate == 'Y') {
      toastr.error('이메일 중복오류 입니다.');
      return;
    }

    if (!vm.joinData.passwd) {
      toastr.error('비밀번호를 입력해주십시오');
      return;
    }

    if (vm.joinData.passwd != vm.joinData.confirmed_passwd) {
      toastr.error('비밀번호와 비밀번호 확인이 일치하지 않습니다.');
      return;
    }

    if (!vm.isIOS) {
      if (!vm.joinData.min2 || !vm.joinData.min3) {
        toastr.error('휴대폰을 입력해주십시오');
        return;
      }
    }

    if (!vm.joinData.name) {
      toastr.error('이름을 입력해주십시오');
      return;
    }

    if (
      vm.selectedUserType1.name != '관계자' && 
      vm.selectedUserType1.name != '후원팬' && 
      vm.selectedUserType1.name != '국제연맹' && 
      vm.selectedUserType1.name != '국내연맹' && 
      vm.selectedUserType1.name != '후원사' && 
      vm.selectedUserType1.name != '일반팬'
    ) {
      if (!vm.isIOS) {
        if (!vm.joinData.height) {
          toastr.error('신장을 입력해주십시오');
          return;
        }
  
        if (!vm.joinData.weight) {
          toastr.error('체중을 입력해주십시오');
          return;
        }
      }
    }

    // if (
    //   vm.selectedUserType1.name != '후원팬' && 
    //   vm.selectedUserType1.name != '일반팬'
    // ) {
    //   if (!vm.joinData.addr.zip || !vm.joinData.addr.detail) {
    //     toastr.error('주소를 입력해주십시오');
    //     return;
    //   }
    // }

    if (!vm.joinData.check1 || !vm.joinData.check2 || !vm.joinData.check3) {
      toastr.error('개인정보취급방침, 부정경쟁방지, 이용약관에 동의해야 합니다.');
      return;
    }

    // if (vm.isDebugger) {

    // }


    // if (!vm.isDebugger && !vm.selectedTeam4) {
    //   toastr.error('소속팀을 선택하세요.');
    //   return;
    // }


    if (vm.selectedTeam4) {
      vm.joinData.team_id = vm.selectedTeam4.id;
    }

    // // 선수일 경우 선택한 팀을 선택한 경우, 해당 팀의 등번호와 겹치는지 검사
    // if (vm.joinData.user_type_id == '1' && vm.joinData.team_id) {
    //   if (vm.selectedTeamPlayers) {
    //     if (_.map(vm.selectedTeamPlayers, 'back_number').indexOf(vm.joinData.back_number) > -1) {
    //       toastr.error('같은 배번의 선수가 등록되어 있습니다. 다른 배번을 선택해주십시오');
    //       return;
    //     }
    //   }
    // }


    // console.log('vm.joinData.team_id', vm.joinData.team_id)
    // return;

    if (vm.joinData.user_type_id == '1') {
      delete vm.joinData.license_id;

      // 선수의 경우 자동승인 안되게 막음
      vm.joinData.appr_id = null;
    } else {
      delete vm.joinData.position_id;
      delete vm.joinData.back_number;
      delete vm.joinData.movement_id;
    }
    delete vm.joinData.verify_code;

    // 감독-선수 소속팀 관련 수정
    // 회원가입시 선택한 팀을 소속팀 목록의 첫번째 팀으로 추가
    if (vm.joinData.user_type_id == '1' || vm.joinData.user_type_id == '4') {
      vm.joinData.teams_ids = vm.joinData.team_id;
    }

    console.log(vm.joinData);

    // return;

    // 배열로 저장되어 있던 값들을 문자열로 변환
    if (vm.joinData.users_ids && vm.joinData.users_ids.length) {
      vm.joinData.users_ids = vm.joinData.users_ids.join(',');
    }
    if (vm.joinData.teams_ids && vm.joinData.teams_ids.length) {
      vm.joinData.teams_ids = vm.joinData.teams_ids.join(',');
    }
    if (vm.joinData.coaches_ids && vm.joinData.coaches_ids.length) {
      vm.joinData.coaches_ids = vm.joinData.coaches_ids.join(',');
    }
    if (vm.joinData.staffs_ids && vm.joinData.staffs_ids.length) {
      vm.joinData.staffs_ids = vm.joinData.staffs_ids.join(',');
    }

    UserService.join(vm.joinData).then(function (res) {
      var data = res.data;
      if (data.result === 'SUC') {
        toastr.success('회원가입 되었습니다. 로그인 후 사용해주십시오');
        $state.go('Accounts.login');
      } else {
        let message;
        switch (data.result) {
          case 'DUP':
            message = '사용 중인 아이디입니다.';
            break;
          case 'EXP':
            message = '관리자 세션 정보가 불일치합니다.'
            break;
          case 'TEAM_NO_MATCH':
            message = '관리자 팀과 개인 팀이 불일치합니다.'
            break;
          case 'REJECTED':
            message = '승인 거절된 팀/협회/회사/일반 입니다.';
            break;
          case 'NO_CODE_INPUT':
            message = '이메일 인증코드 입력값이 없습니다.'
            break;
          case 'NO_CODE':
            message = '인증메일 발송을 해주십시오';
            break;
          case 'CODE_MISMATCH':
            message = '이메일 인증코드를 받은 이메일 주소와 가입하시려는 이메일 주소가 다릅니다.';
            break;
          case 'DUP_BACK_NUMBER':
            message = '같은 배번의 선수가 등록되어 있습니다. 다른 배번을 선택해주십시오';
            break;
          case 'DUP_USER_TYPE':
            message = '같은 회원 구분이 이미 팀에 등록되어 있어서 가입하실 수 없습니다.';
            break;
          default:
            message = '회원가입 중 오류가 발생하였습니다.';
            break;
        }
        toastr.error(message);

        // 회원가입 실패시 문자열을 다시 배열로 변환
        if (vm.joinData.users_ids && typeof vm.joinData.users_ids === 'string') {
          vm.joinData.users_ids = vm.joinData.users_ids.split(',');
        }
        if (vm.joinData.teams_ids && typeof vm.joinData.teams_ids === 'string') {
          vm.joinData.teams_ids = vm.joinData.teams_ids.split(',');
        }
        if (vm.joinData.coaches_ids && typeof vm.joinData.coaches_ids === 'string') {
          vm.joinData.coaches_ids = vm.joinData.coaches_ids.split(',');
        }
        if (vm.joinData.staffs_ids && typeof vm.joinData.staffs_ids === 'string') {
          vm.joinData.staffs_ids = vm.joinData.staffs_ids.split(',');
        }
      }
    });
  };

  // view 가 load 된 이후에 실행
  $scope.$on('$viewContentLoaded', function () {

  });



  vm.setData = function (data, what) {
    console.log(data);
    if (what = 'agent') {
      vm.agency = data
      vm.joinData.agent_id = data.id;
    }
  }




  // 우편번호 검색 팝업
  vm.openJusoPopup = function () {
    new daum.Postcode({
      oncomplete: function (data) {
        $timeout(function () {
          vm.joinData.addr.zip = data.zonecode;
          vm.joinData.addr.detail = data.address;

          $('#addr').focus();
        }, 0);
      }
    }).open();
  };


  vm.searchedJusoList = [];
  vm.selectedJuso = null;
  vm.searchJuso = function ($event) {
    $event.preventDefault();

    if (!vm.joinData.addr.detail) {
      toastr.error('검색어를 입력 후 우편번호 검색 버튼을 클릭해주십시오');
      $('#addr').focus();
      return;
    }

    var url = AppSettings.apiUrl.juso,
      params = {
        confmKey: AppSettings.apiKey.juso,
        currentPage: 1,
        countPerPage: 1000,
        keyword: vm.joinData.addr.detail,
        resultType: 'json'
      };

    CommonService.post(url, params)
      .then(function(result) {
        vm.searchedJusoList = result.data.results.juso;
      });
  }

  $scope.$watch('vm.selectedJuso', function(newVal, oldVal) {
    if (newVal) {
      vm.joinData.addr.zip = newVal.zipNo;
      vm.joinData.addr.detail = newVal.roadAddr;

      vm.searchedJusoList = [];
      vm.selectedJuso = null;
    }
  });


  // 도로명 주소 API 승인키
  // U01TX0FVVEgyMDE4MDMxNzAwMjYxMTEwNzczNTE=
  // 검색 API - https://www.juso.go.kr/addrlink/devAddrLinkRequestGuide.do?menu=roadApi

//   /*
//   <script language="javascript">
// //페이지 이동
// function goPage(pageNum){
// 	document.form.currentPage.value=pageNum;
// 	getAddr();
// }
// // json타입 페이지 처리 (주소정보 리스트 makeListJson(jsonStr); 다음에서 호출)
// /* 
// *  json타입으로 페이지 처리시 수정 
// *  function pageMake(jsonStr){ 
// *  	var total = jsonStr.results.common.totalCount; // 총건수 
// */

// // xml타입 페이지 처리 (주소정보 리스트 makeList(xmlData); 다음에서 호출) 
// function pageMake(xmlStr){
// 	var total = $(xmlStr).find("totalCount").text(); // 총건수
// 	var pageNum = document.form.currentPage.value;// 현재페이지
// 	var paggingStr = "";
// 	if(total < 1){
// 	}else{
// 		var PAGEBLOCK=document.form.countPerPage.value;
// 		var pageSize=document.form.countPerPage.value;
// 		var totalPages = Math.floor((total-1)/pageSize) + 1;
// 		var firstPage = Math.floor((pageNum-1)/PAGEBLOCK) * PAGEBLOCK + 1;		
// 		if( firstPage <= 0 ) firstPage = 1;		
// 		var lastPage = firstPage-1 + PAGEBLOCK;
// 		if( lastPage > totalPages ) lastPage = totalPages;		
// 		var nextPage = lastPage+1 ;
// 		var prePage = firstPage-5 ;		
// 		if( firstPage > PAGEBLOCK ){
// 			paggingStr +=  "<a href='javascript:goPage("+prePage+");'>◁</a>  " ;
// 		}		
// 		for( i=firstPage; i<=lastPage; i++ ){
// 			if( pageNum == i )
// 				paggingStr += "<a style='font-weight:bold;color:blue;font-size:15px;' href='javascript:goPage("+i+");'>" + i + "</a>  ";
// 			else
// 				paggingStr += "<a href='javascript:goPage("+i+");'>" + i + "</a>  ";
// 		}		
// 		if( lastPage < totalPages ){
// 			paggingStr +=  "<a href='javascript:goPage("+nextPage+");'>▷</a>";
// 		}		
// 		$("#pageApi").html(paggingStr);
// 	}	
// }
// </script>
// // html 소스에서 검색결과 리스트 다음에 추가하여 구성하세요!(<div id="list" ></div>)	
// <div class="paginate" id="pageApi"></div>
// */

  // 인증메일 발송
  vm.generateCode = function () {
    if (!vm.joinData.login_id) {
      toastr.error('이메일을 입력해주십시오');
      return;
    }

    UserService.generateCode({ email: vm.joinData.login_id }).then(function (res) {
      var data = res.data;
      if (data.result === 'SUC') {
        toastr.success('인증메일을 발송중입니다. 잠시만 기다려주십시오');
        UserService.sendCodeMail({ email: vm.joinData.login_id }).then(function (res) {
          var data = res.data;
          if (data.result === 'SUC') {
            toastr.success('인증메일이 발송되었습니다. 메일에 있는 인증코드를 입력해주십시오');
          }
        });
      }
    });
  };

  vm.trustAsHtml = function(value) {
    return $sce.trustAsHtml(value);
  };


}

export default {
  name: 'AccountsJoinCtrl',
  fn: AccountsJoinCtrl
};
